<template>
  <div style="font-size: 12px;" v-html="$t('internal.copyright')"></div>
</template>

<script>
export default {
  name: 'InternalCopyright',
}
</script>
